import * as React from "react";
import {useId} from "react";
import {DatePickerInput} from "@/shared/ui/primitives/DatePickerInput";
import {FormGroup} from "@/shared/ui/form/FormGroup";
import type {LegacySingleDatePickerDrops} from "@/shared/ui/compatibility/useLegacySingleDatePicker";
import {clsx} from "clsx";
import {Temporal} from "@js-temporal/polyfill";

interface DatePickerFormGroupProps {
	label: string;
	value: Temporal.PlainDate | null;
	onValueChange: (value: Temporal.PlainDate | null) => void;
	drops?: LegacySingleDatePickerDrops;
	labelColClass?: string;
	inputColClass?: string;
	error?: string;
	disabled?: boolean;
}

export function DatePickerFormGroup({
	                                    label,
	                                    value,
	                                    onValueChange,
	                                    drops,
	                                    labelColClass,
	                                    inputColClass,
	                                    error,
	                                    disabled
                                    }: DatePickerFormGroupProps) {
	const inputId = useId();
	return (
		<FormGroup label={label} htmlFor={inputId} labelColClass={labelColClass} inputColClass={inputColClass} error={error}>
			<div className="input-group">
				<div className="input-group-btn">
					<label htmlFor={inputId} className={clsx("btn btn-default btn-icon", disabled && "disabled")}>
						<i className="far fa-calendar-day" />
					</label>
				</div>
				<DatePickerInput id={inputId} value={value} onValueChange={onValueChange} drops={drops} disabled={disabled} />
			</div>
		</FormGroup>
	);
}
